import { attachTabSync } from '@rocketlane/state-db';
import { getTabSync } from '../tab-sync';
import { projectCollection } from './project-collection';
/**
 * Bind the project collection to the cross-tab channel.
 *
 * Peer payloads are applied in `merge` mode (the adapter's default) for the
 * same reason `fetchers.ts` pushes lists that way: one `projectId` is served at
 * several fidelities (full detail, light, meta, RM), so a peer whose newest
 * value came from a light list must not replace a fuller detail record here and
 * drop `fields[]` / `metrics`.
 *
 * No custom `apply` — unlike tasks, Project has no element-wise nested
 * collection needing id-keyed merging, so the shallow overlay is correct.
 */ export const attachProjectTabSync = ()=>attachTabSync({
        collection: projectCollection,
        sync: getTabSync()
    });
